import { ExtendedFlightBasket } from '../interfaces';
import { getUpgradeFromFlight } from './data.utils';

export const getFlightById = (flightsBasket: ExtendedFlightBasket[], flightId: string): ExtendedFlightBasket => {
  return flightsBasket.find((flightBasket) => flightBasket.flight.segmentInfo.flightId === flightId);
};

export const getFlightByGroup = (flightsBasket: ExtendedFlightBasket[], group: number): ExtendedFlightBasket[] => {
  return flightsBasket.filter((flightBasket) => flightBasket.flight.segmentInfo.group === group);
};

export const basketHasWaitlistUpgrade = (flights: ExtendedFlightBasket[]): boolean => {
  return flights.reduce((acc, cur) => {
    const upgrade = getUpgradeFromFlight(cur.flight, cur.productName);

    return acc || upgrade.isWaitlist;
  }, false);
};
